import React from 'react';
import {TbChartBar, TbChartPie} from 'react-icons/tb';
import {BiLineChart, BiWorld, BiChild} from 'react-icons/bi';
import {Route} from 'react-router';
import {EmbeddedSupersetDashboardPage} from 'simplifyworks-ext-ui';
import localization from '../localization/index';
import {FOEDUS_ROLE} from '../domain/constants';

const PATH_PREFIX = '/statistics/';
const KEY = 'statistics';
const NAME = 'STATISTICS';

const menu = {

	'foedusStatisticsExchangeActivity': {
		icon: BiLineChart,
		labelKey: 'foedus-statistics-exchange-activity',
		path: PATH_PREFIX + 'exchange-activity',
		rolesAllowed: [FOEDUS_ROLE.ADMIN, FOEDUS_ROLE.COUNTRY_MANAGER, FOEDUS_ROLE.COORDINATOR]
	},

	'foedusStatisticsOrgans': {
		icon: TbChartPie,
		labelKey: 'foedus-statistics-organs',
		path: PATH_PREFIX + 'organs',
		rolesAllowed: [FOEDUS_ROLE.ADMIN, FOEDUS_ROLE.COUNTRY_MANAGER, FOEDUS_ROLE.COORDINATOR]
	},

	'foedusStatisticsCountries': {
		icon: BiWorld,
		labelKey: 'foedus-statistics-countries',
		path: PATH_PREFIX + 'countries',
		rolesAllowed: [FOEDUS_ROLE.ADMIN, FOEDUS_ROLE.COUNTRY_MANAGER, FOEDUS_ROLE.COORDINATOR]
	},

	'foedusStatisticsPaediatrics': {
		icon: BiChild,
		labelKey: 'foedus-statistics-paediatrics',
		path: PATH_PREFIX + 'paediatrics',
		rolesAllowed: [FOEDUS_ROLE.ADMIN, FOEDUS_ROLE.COUNTRY_MANAGER, FOEDUS_ROLE.COORDINATOR]
	}

};

const routes = [
	<Route
		exact
		path={PATH_PREFIX + 'exchange-activity'}
		key={'foedus-statistics-exchange-activity'}
		components={{
			title: () => 'foedus-statistics-exchange-activity',
			main: () => (
				<EmbeddedSupersetDashboardPage
					dashboardIdRest="/api/foedus/superset/dashboard-info?dashboardType=EXCHANGE_ACTIVITY"
					wrapperId="foedus-statistics-exchange-activity-wrapper"
				/>
			)
		}}
		rolesAllowed={[FOEDUS_ROLE.ADMIN, FOEDUS_ROLE.COUNTRY_MANAGER, FOEDUS_ROLE.COORDINATOR]}
	/>,

	<Route
		exact
		path={PATH_PREFIX + 'organs'}
		key={'foedus-statistics'}
		components={{
			title: () => 'foedus-statistics-organs',
			main: () => (
				<EmbeddedSupersetDashboardPage
					dashboardIdRest="/api/foedus/superset/dashboard-info?dashboardType=ORGANS"
					wrapperId="foedus-statistics-organs-wrapper"
				/>
			)
		}}
		rolesAllowed={[FOEDUS_ROLE.ADMIN, FOEDUS_ROLE.COUNTRY_MANAGER, FOEDUS_ROLE.COORDINATOR]}
	/>,

	<Route
		exact
		path={PATH_PREFIX + 'countries'}
		key={'foedus-statistics'}
		components={{
			title: () => 'foedus-statistics-countries',
			main: () => (
				<EmbeddedSupersetDashboardPage
					dashboardIdRest="/api/foedus/superset/dashboard-info?dashboardType=COUNTRIES"
					wrapperId="foedus-statistics-countries-wrapper"
				/>
			)
		}}
		rolesAllowed={[FOEDUS_ROLE.ADMIN, FOEDUS_ROLE.COUNTRY_MANAGER, FOEDUS_ROLE.COORDINATOR]}
	/>,

	<Route
		exact
		path={PATH_PREFIX + 'paediatrics'}
		key={'foedus-statistics'}
		components={{
			title: () => 'foedus-statistics-paediatrics',
			main: () => (
				<EmbeddedSupersetDashboardPage
					dashboardIdRest="/api/foedus/superset/dashboard-info?dashboardType=PAEDIATRICS"
					wrapperId="foedus-statistics-paediatrics-wrapper"
				/>
			)
		}}
		rolesAllowed={[FOEDUS_ROLE.ADMIN, FOEDUS_ROLE.COUNTRY_MANAGER, FOEDUS_ROLE.COORDINATOR]}
	/>
];

const Module = {
	name: NAME,
	key: KEY,
	icon: TbChartBar,
	portlets: [],
	menu,
	routes,
	localization
};

export default Module;
